import { Link, type LinkProps } from '@tanstack/react-router';
import { CaretLeft } from '@phosphor-icons/react';
import { Icon } from '../Icon';
import { StepProgress } from '../ui/step-progress';

export const ONBOARDING_STEPS = 5;

export interface OnboardingHeaderProps {
  /** 1-based. */
  step: number;
  backTo: LinkProps['to'];
}

/** "‹ Back        Step 2 of 5" over the five-segment progress bar (Figma C01.2–C01.6). */
export function OnboardingHeader({ step, backTo }: OnboardingHeaderProps) {
  return (
    <div className="flex flex-col gap-(--mbm-space-3)">
      <div className="flex items-center justify-between">
        <Link
          to={backTo}
          className="inline-flex items-center gap-(--mbm-space-1) text-label-medium text-text-secondary hover:text-text-primary focus-visible:outline-none focus-visible:shadow-(--mbm-shadow-focus-ring) rounded-(--mbm-radius-xs)"
        >
          <Icon icon={CaretLeft} size="sm" />
          Back
        </Link>
        <span className="text-label-small text-text-tertiary">
          Step {step} of {ONBOARDING_STEPS}
        </span>
      </div>
      <StepProgress steps={ONBOARDING_STEPS} current={step} />
    </div>
  );
}
